module.exports = __webpack_public_path__ + "static/img/lottery-btn-go.ca49567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/lottery-btn-go.png
// module id = 93YE
// module chunks = 215